import { Component, OnInit } from "@angular/core";
import { SessionService } from "../common/services/session.service";
import { RecentDocService } from "./RecentDocService/api/recent-doc.service";

@Component({
  selector: "app-recent-doc",
  templateUrl: "./recent-doc.component.html",
  styleUrls: ["./recent-doc.component.scss"],
})
export class RecentDocComponent implements OnInit {
  recentData: any;
  userInfo: any;

  constructor(
    private apiService: RecentDocService,
    private session: SessionService
  ) {}

  getDocData() {
    this.apiService.getRecentDocData().subscribe((data: any) => {
      this.recentData = data;
    });
  }

  ngOnInit() {
    setTimeout(() => {
      this.userInfo = this.session.getUserInfo();
      this.getDocData();
    });
  }
}
